import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import './Login.css';

function ClinicLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { login } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      const userData = await login(email, password);

      if (userData.role === 'doctor') {
        navigate('/doctor-dashboard');
      } else if (userData.role === 'pharmacy') {
        navigate('/pharmacy-dashboard');
      } else if (userData.role === 'lab') {
        navigate('/lab-dashboard');
      } else if (userData.role === 'reception') {
        navigate('/reception-dashboard');
      } else {
        setError('Invalid staff credentials');
        setLoading(false);
      }
    } catch (err) {
      setError(err.message || 'Invalid email or password');
      setLoading(false);
    }
  }

  return (
    <>
      <Navbar />
      <div className="login-wrapper">
        <div className="login-background-pattern"></div>
        <div className="login-container-centered">
          <motion.div
            className="login-card"
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <div className="login-card-header">
              <h1>Healthcare Staff</h1>
              <p className="login-subtitle">Access your dashboard</p>
            </div>

            {error && (
              <div className="alert-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label>Email address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="staff@clinic.com"
                />
              </div>

              <div className="input-group">
                <label>Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  placeholder="••••••••"
                />
              </div>

              <button type="submit" disabled={loading} className="btn-primary">
                {loading ? 'Signing in...' : 'Sign in'}
              </button>
            </form>

            <div className="login-footer">
              <button onClick={() => navigate('/')} className="link-button">
                ← Back to portal selection
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
}

export default ClinicLogin;